function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { __decorate } from '../../node_modules/tslib/tslib.es6.js';
import Combobox from '@ambiki/combobox';
import { property, target, targets, registerElement, ImpulseElement } from '@ambiki/impulse';
import { isLooselyFocusable } from '../../helpers/focus.js';
import useFloatingUI from '../../hooks/use_floating_ui.js';
import useOutsideClick from '../../hooks/use_outside_click.js';
import LocalSearch from './local_search.js';
import MultipleSelect from './multiple_select.js';
import RemoteSearch from './remote_search.js';
import SingleSelect from './single_select.js';

var AwcAutocompleteElement = /*#__PURE__*/function (_ImpulseElement) {
  _inherits(AwcAutocompleteElement, _ImpulseElement);

  var _super = _createSuper(AwcAutocompleteElement);

  function AwcAutocompleteElement() {
    var _this;

    _classCallCheck(this, AwcAutocompleteElement);

    _this = _super.call(this);
    /**
     * Shows/hides the listbox element.
     */

    _this.open = false;
    /**
     * Whether the autocomplete element is disabled or not.
     */

    _this.disabled = false;
    /**
     * Whether the autocomplete element is required or not.
     */

    _this.required = false;
    /**
     * Whether multiple values can be selected or not.
     */

    _this.multiple = false;
    /**
     * The param that is appended when making a network request.
     * Example: /users?q=john
     */

    _this.param = 'q';
    /**
     * If `true`, the listbox will automatically adjust its height based on its content.
     * This helps avoid scrollbars by fitting the content dynamically.
     */

    _this.autoSize = false;
    /**
     * The number of pixels of extra space to add beyond the content's height
     * when `autoSize` is enabled. Acts as vertical padding.
     */

    _this.autoSizePadding = 4;
    _this.firstFocus = true;
    _this.preventOutsideClickEvent = false;
    _this.handleFormReset = _this.handleFormReset.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * @private
   * Called when the element is connected to the DOM.
   */


  _createClass(AwcAutocompleteElement, [{
    key: "connected",
    value: function connected() {
      var _this2 = this;

      var _a;

      (_a = this.form) === null || _a === void 0 ? void 0 : _a.addEventListener('reset', this.handleFormReset);
      this.floatingUI = useFloatingUI(this, {
        referenceElement: this.control,
        popupElement: this.listbox,
        placement: 'bottom',
        sync: 'width',
        offsetOptions: 4,
        autoSize: this.autoSize ? 'height' : undefined,
        autoSizePadding: this.autoSizePadding
      });
      useOutsideClick(this, {
        boundaries: [this.control, this.listbox],
        callback: function callback(event, target) {
          // Since the blur event fires before the click event, we need to consider the case when the input is blurred so
          // that we don't prevent the click event from happening.
          if (_this2.preventOutsideClickEvent && !isLooselyFocusable(target)) {
            event.preventDefault();
          } else if (_this2.open) {
            _this2.hide();
          }

          _this2.preventOutsideClickEvent = false;
        }
      });
      this.combobox = new Combobox(this.input, this.listbox, {
        multiple: this.multiple
      });
      this.selectVariant = this.multiple ? new MultipleSelect(this) : new SingleSelect(this);
      this.selectVariant.connected();
      this.searchVariant = this.src ? new RemoteSearch(this) : new LocalSearch(this);
      this.selectVariant.required = this.required;
    }
    /**
     * @private
     * Called when the element is disconnected from the DOM.
     */

  }, {
    key: "disconnected",
    value: function disconnected() {
      var _a;

      this.hide();
      (_a = this.form) === null || _a === void 0 ? void 0 : _a.removeEventListener('reset', this.handleFormReset);
      this.firstFocus = true;
      this.preventOutsideClickEvent = false;
    }
    /**
     * @private
     * Called when the `disabled` attribute changes.
     */

  }, {
    key: "disabledChanged",
    value: function disabledChanged(value) {
      this.input.disabled = value;

      if (this.clearButton) {
        this.clearButton.disabled = value;
      }

      var _iterator = _createForOfIteratorHelper(this.tagDismissButtons),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var button = _step.value;
          button.disabled = value;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * @private
     * Called when the `required` attribute changes.
     */

  }, {
    key: "requiredChanged",
    value: function requiredChanged(value) {
      this.selectVariant.required = value;
    }
    /**
     * @private
     * Called when the `src` attribute changes.
     */

  }, {
    key: "srcChanged",
    value: function srcChanged(src) {
      // Clear the selected value without emitting any events to avoid invalid combinations.
      this.clear();
      this.searchVariant = src ? new RemoteSearch(this) : new LocalSearch(this);
    }
    /**
     * @private
     */

  }, {
    key: "handleMousedown",
    value: function handleMousedown(event) {
      // Fix focus jitter issue when clicking outside the input element.
      if (event.target !== this.input) {
        event.preventDefault();
      }
    }
    /**
     * @private
     */

  }, {
    key: "handleClick",
    value: function handleClick(event) {
      if (this.disabled) return;
      this.focus();
      var target = event.target;

      if (target.hasAttribute('data-trigger')) {
        this.show();
      }

      if (this.firstFocus && this.input.value) {
        this.input.select();
      }

      this.firstFocus = false;
    }
    /**
     * @private
     */

  }, {
    key: "handleInputMousedown",
    value: function handleInputMousedown(event) {
      if (this.disabled) return;

      if (event.buttons === 1) {
        this.show();
      }
    }
    /**
     * @private
     */

  }, {
    key: "handleInputBlur",
    value: function () {
      var _handleInputBlur = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.preventOutsideClickEvent = this.open;
                _context.next = 3;
                return this.hide();

              case 3:
                this.firstFocus = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleInputBlur() {
        return _handleInputBlur.apply(this, arguments);
      }

      return handleInputBlur;
    }()
    /**
     * @private
     */

  }, {
    key: "handleInputKeydown",
    value: function handleInputKeydown(event) {
      var _a;

      switch (event.key) {
        case 'Enter':
          // Prevent accidental form submissions.
          if (this.open) {
            event.preventDefault();
          }

          break;

        case 'Escape':
          if (this.open) {
            // Prevent dialogs from closing accidentally.
            event.preventDefault();
            event.stopPropagation();
            this.hide();
          }

          break;

        case 'ArrowDown':
          if (event.altKey && !this.open) {
            event.preventDefault();
            this.show();
          }

          break;

        case 'ArrowUp':
          if (event.altKey && this.open) {
            event.preventDefault();
            this.hide();
          }

          break;

        case 'Backspace':
          if (this.multiple && !this.input.value) {
            var tag = this.removeLastTag();

            if (tag) {
              event.preventDefault();
              var value = (_a = tag.getAttribute('value')) !== null && _a !== void 0 ? _a : '';
              var text = tag.dataset.text;
              this.emit('remove', {
                detail: {
                  target: tag,
                  value: value,
                  text: text || ''
                }
              });
            }
          }

          break;
      }
    }
    /**
     * @private
     * Handles the `combobox:commit` event from the combobox.
     */

  }, {
    key: "handleCommit",
    value: function handleCommit(event) {
      var _a;

      event.stopPropagation();
      var option = event.target;
      if (!(option instanceof HTMLElement)) return;
      this.selectVariant.select(option);
      var value = (_a = option.getAttribute('value')) !== null && _a !== void 0 ? _a : '';
      var text = option.dataset.text;
      this.emit('commit', {
        detail: {
          target: option,
          value: value,
          text: text || ''
        }
      });
    }
    /**
     * @private
     */

  }, {
    key: "handleFormReset",
    value: function handleFormReset() {
      this.reset();
      this.hide();
      this.emit('reset');
    }
    /**
     * @private
     */

  }, {
    key: "handleClear",
    value: function handleClear() {
      this.clear();
      this.hide();
      this.emit('clear');
    }
    /**
     * @private
     * Removes the tag when the "X" button is clicked.
     */

  }, {
    key: "handleTagRemove",
    value: function handleTagRemove(event) {
      var _a;

      var tag = event.target.closest('[data-behavior="tag"]');
      if (!tag) return;
      this.removeTag(tag);
      var value = (_a = tag.getAttribute('value')) !== null && _a !== void 0 ? _a : '';
      var text = tag.dataset.text;
      this.emit('remove', {
        detail: {
          target: tag,
          value: value,
          text: text || ''
        }
      });
    }
    /**
     * @private
     */

  }, {
    key: "handleInput",
    value: function handleInput(event) {
      var target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      var query = target.value.trim();
      this.show();
      this.searchVariant.search(query);
    }
    /**
     * Shows the listbox element.
     */

  }, {
    key: "show",
    value: function show() {
      if (this.open) return;
      this.emit('show');
      this.open = true;
      this.floatingUI.start();
      this.combobox.start();
      this.selectVariant.start();
      this.searchVariant.start();
      this.emit('shown');
    }
    /**
     * Hides the listbox element.
     */

  }, {
    key: "hide",
    value: function () {
      var _hide = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.open) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                this.emit('hide');
                this.open = false;
                this.combobox.stop();
                this.selectVariant.stop();
                this.searchVariant.stop();
                this.removeAttribute('no-options');
                this.removeAttribute('error');
                _context2.next = 11;
                return this.floatingUI.stop();

              case 11:
                this.emit('hidden');

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function hide() {
        return _hide.apply(this, arguments);
      }

      return hide;
    }()
    /**
     * Sets the value of the element. If options are fetched from a remote source, the `text` param is required.
     * @param value - The value of the option.
     * @param text - The text of the option.
     */

  }, {
    key: "setValue",
    value: function setValue(value, text) {
      var option = this.options.find(function (o) {
        return o.getAttribute('value') === value;
      });
      var textValue = text || (option === null || option === void 0 ? void 0 : option.getAttribute('data-text')) || '';
      this.selectVariant.setValue(value, textValue);
    }
    /**
     * Removes a value from the element.
     * @param value - The value of the option (you do not have to provide the value arg for a single select).
     */

  }, {
    key: "removeValue",
    value: function removeValue(value) {
      if (this.multiple && value) {
        this.selectVariant.removeValue(value);
        return;
      }

      this.selectVariant.clear();
    }
    /**
     * Activates an option by setting the `data-active` attribute.
     * @param option - The option you want to activate.
     * @param scroll - When true, it scrolls the option to view (by default, it is true).
     */

  }, {
    key: "activate",
    value: function activate(option) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$scroll = _ref.scroll,
          scroll = _ref$scroll === void 0 ? true : _ref$scroll;

      this.combobox.activate(option, {
        scroll: scroll
      });
    }
    /**
     * Deactivates the active option by removing the `data-active` attribute.
     */

  }, {
    key: "deactivate",
    value: function deactivate() {
      this.combobox.deactivate();
    }
    /**
     * Focuses on the input element.
     * @param options - See https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#parameters
     */

  }, {
    key: "focus",
    value: function focus(options) {
      this.input.focus(options);
    }
    /**
     * Blurs the input element.
     */

  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
    /**
     * Resets the value to the default value.
     */

  }, {
    key: "reset",
    value: function reset() {
      this.selectVariant.reset();
    }
    /**
     * Clears the selected value.
     */

  }, {
    key: "clear",
    value: function clear() {
      this.selectVariant.clear();
    }
    /**
     * Updates the listbox position.
     */

  }, {
    key: "reposition",
    value: function () {
      var _reposition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.floatingUI.update();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function reposition() {
        return _reposition.apply(this, arguments);
      }

      return reposition;
    }()
  }, {
    key: "removeLastTag",
    value: function removeLastTag() {
      var lastTag = this.tags[this.tags.length - 1];
      if (!lastTag) return;
      this.removeTag(lastTag);
      return lastTag;
    }
  }, {
    key: "removeTag",
    value: function removeTag(tag) {
      var value = tag.getAttribute('value');
      if (!value) return;
      this.removeValue(value);
    }
    /**
     * @private
     */

  }, {
    key: "checkIfListIsEmpty",
    value: function checkIfListIsEmpty() {
      this.toggleAttribute('no-options', this.visibleOptions.length === 0);
    }
    /**
     * @private
     */

  }, {
    key: "toggleSelectedClass",
    value: function toggleSelectedClass(value) {
      this.classList.toggle('awc-autocomplete--selected', value);
    }
    /**
     * Returns the selected value.
     */

  }, {
    key: "value",
    get: function get() {
      var _a, _b;

      if (this.multiple) {
        return this.tags.map(function (tag) {
          var _a;

          return (_a = tag.getAttribute('value')) !== null && _a !== void 0 ? _a : '';
        });
      }

      return (_b = (_a = this.querySelector('input[data-behavior="hidden-field"]')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
    }
    /**
     * Returns all the options.
     */

  }, {
    key: "options",
    get: function get() {
      return this.combobox.options;
    }
    /**
     * Returns all the visible options.
     */

  }, {
    key: "visibleOptions",
    get: function get() {
      return this.options.filter(function (option) {
        return !option.hidden;
      });
    }
    /**
     * Returns the option that has the `data-active` attribute.
     */

  }, {
    key: "activeOption",
    get: function get() {
      return this.combobox.activeOption;
    }
    /**
     * Returns the parent form element.
     */

  }, {
    key: "form",
    get: function get() {
      return this.closest('form');
    }
    /**
     * @private
     */

  }, {
    key: "tags",
    get: function get() {
      return _toConsumableArray(this.querySelectorAll('[data-behavior="tag"]'));
    }
  }]);

  return AwcAutocompleteElement;
}(ImpulseElement);

__decorate([property({
  type: Boolean
})], AwcAutocompleteElement.prototype, "open", void 0);

__decorate([property({
  type: Boolean
})], AwcAutocompleteElement.prototype, "disabled", void 0);

__decorate([property({
  type: Boolean
})], AwcAutocompleteElement.prototype, "required", void 0);

__decorate([property({
  type: Boolean
})], AwcAutocompleteElement.prototype, "multiple", void 0);

__decorate([property()], AwcAutocompleteElement.prototype, "src", void 0);

__decorate([property()], AwcAutocompleteElement.prototype, "param", void 0);

__decorate([property({
  type: Boolean
})], AwcAutocompleteElement.prototype, "autoSize", void 0);

__decorate([property({
  type: Number
})], AwcAutocompleteElement.prototype, "autoSizePadding", void 0);

__decorate([target()], AwcAutocompleteElement.prototype, "control", void 0);

__decorate([target()], AwcAutocompleteElement.prototype, "input", void 0);

__decorate([target()], AwcAutocompleteElement.prototype, "listbox", void 0);

__decorate([target()], AwcAutocompleteElement.prototype, "optionsContainer", void 0);

__decorate([target()], AwcAutocompleteElement.prototype, "clearButton", void 0);

__decorate([targets()], AwcAutocompleteElement.prototype, "tagDismissButtons", void 0);

__decorate([targets()], AwcAutocompleteElement.prototype, "groups", void 0);

AwcAutocompleteElement = __decorate([registerElement('awc-autocomplete')], AwcAutocompleteElement);
var AwcAutocompleteElement$1 = AwcAutocompleteElement;
export { AwcAutocompleteElement$1 as default };